import React from "react";

import ErrorIcon from "./../../../../../images/campaign-creation/error.svg";

import * as SC from "./RightSideBar.styled";
import { PreviewStore, withRefluxStore } from "../../../../Stores";
import { useTranslation } from "react-i18next";

const STEP_PREVIEWS_NEW = "STEP_PREVIEWS_NEW";

const RightSideBar = ({ adErrors, currentStep, mediaAsset = false }) => {
  const { t } = useTranslation();
  const hasErrors = adErrors.some((error) => error.hasError);

  if (currentStep === STEP_PREVIEWS_NEW) {
    return (
      <SC.ContainersWrapper isMediaAsset={mediaAsset}>
        <SC.MediaContainer />
        {hasErrors && (
          <SC.ErrorContainer>
            <SC.ErrorTitle>
              <ErrorIcon />
              {t("Error")}
            </SC.ErrorTitle>
            {adErrors.map((error, index) => {
              return <SC.ErrorMessage key={index}>{error.errorMessage}</SC.ErrorMessage>;
            })}
          </SC.ErrorContainer>
        )}
      </SC.ContainersWrapper>
    );
  }
  return <></>;
};

export default withRefluxStore(RightSideBar, [PreviewStore], ["adErrors"]);
